import { apiAddToBag } from '../../../actions/bag';
import { showBag } from '../../../actions/masthead/header';
import { closeLayer } from '../../../actions/layer';
import { selectSku } from '../../../actions/product';

export const addToBagAndView = (styleColourCode, quantity) => dispatch => {
  dispatch(apiAddToBag(styleColourCode, quantity));
  dispatch(showBag());
};

export const selectSkuAndCloseModal = sku => dispatch => {
  dispatch(closeLayer());
  dispatch(selectSku(sku));
};

/**
 * @param {string} params
 * @returns {string}
 */
export const getStyleColourCodeFromParams = params =>
  (params.slug || '').replace(/.*-([A-Za-z0-9]*)$/, '$1').toUpperCase();

export const getSlugFromUrl = (urlWithBasePath = '') => {
  let url;
  // Remove the query string if it exists. We're only interested in getting the
  // slug here. If the query string is preserved it causes problems, such as making the
  // API call to get reviews. See Gitlab #2663
  url = urlWithBasePath.replace(/\?.*$/, '');
  // If the url contains an actual base path, such as '/us/', then remove it
  url = url.replace(/^(\/[a-z]{2}\/)/, '/');
  return url.replace(/\/products\/([A-z\-0-9]+)\/(write-review\/)?/, '$1');
};
